import React from "react";
import { Col, Drawer, Row } from "@payping/web-components";

type Props = {
  submit: React.ReactNode;
  back: React.ReactNode;
  open: boolean;
  zIndex?: number;
};

const LittleActionDrawer: React.FC<Props> = (props) => {
  const { back, submit, open, zIndex } = props;
  return (
    <Drawer zIndex={zIndex} placement={"bottom"} closable={false} mask={false} open={open} height={80}>
      <Row gutter={[8, 8]}>
        <Col flex={1}>{submit}</Col>
        <Col flex={1}>{back}</Col>
      </Row>
    </Drawer>
  );
};

export default LittleActionDrawer;
